import React from 'react';
import { LoadingIcon } from '@icons';

const GeolocationLoader = React.memo(({ loading }: { loading: boolean }) => (
  <>
    {loading && (
      <div className="flex items-center justify-center h-96">
        <LoadingIcon size="md" />
      </div>
    )}
  </>
));

GeolocationLoader.displayName = 'GeolocationLoader';

export default GeolocationLoader;
